/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui'; 
import { Card, CardContent, Container } from '@mui/material';




const Aboutus = () => {
    const { classes } = useStyles()

    return (
        <>

            <Grid container spacing={4}>

                <Grid item xs={12} sm={12} md={12}  >
                    <div >
                        <Typography variant="h1" align="center" style={{ marginTop: '100px', marginBottom: '20px' }} paragraph>
                            About Us
                        </Typography>
                        <div className={classes.sectionTitleBorder}></div>
                        <div className={classes.divinfoNavigation}>

                            <Container className={classes.cardGrid} maxWidth="lg">
                                {/* End hero unit */}
                                <Grid container spacing={4}>
                                    <Grid item xs={12} sm={612} md={12}>
                                        <Card className={classes.cardService} >
                                            <CardContent className={classes.cardContent}>

                                                <img src="assets/images/logo/logo.png" alt="" style={{ width: "100px", heignt: "100px" }} className='AlignCenter' />

                                                <Typography className={classes.blocksTypoInfo} variant="h3" align="center">
                                                    DihDah admin web
                                                </Typography> 
                                            </CardContent>


                                        </Card>
                                    </Grid>


                                </Grid>
                            </Container>

                        </div>
                    </div>
                </Grid>


            </Grid>

        </>
    );
}
const useStyles = makeStyles({ "name": { Aboutus } })(theme => ({
    root: {
    },
    cardContent: {
        margin: '20px'
    },
    imageDotedDescp: {
        transition: 'transform .2s',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        "&:hover": {
            transform: 'scale(1.2)',

        }
    },
    sectionTitleBorder: {
        width: '50px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',

    },
    divinfoNavigation: {
        marginTop: '100px'
    },
    blocksTypoInfo: {
        lineHeight: "2.5em!important"
    },
    blocksTypoInfoList: {
        padding: '0',
        color: theme.palette.primary.main

    }
}));
 

export default Aboutus;